<mat-sidenav-container class="sidenav-container">
  <mat-sidenav mode="side" opened class="sidenav">
    <div class="sidenav-header">
      <h2>Панель керування</h2>
    </div>
    <mat-nav-list>
      @for (item of menuItems; track item.route) {
        <a mat-list-item [routerLink]="item.route" routerLinkActive="active-link" class="sidenav-item">
          <mat-icon matListItemIcon [fontIcon]="item.icon"></mat-icon>
          <span matListItemTitle>{{ item.label }}</span>
        </a>
      }
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
